import { Text } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { VK_UI_DARK_THEME } from 'reactApp/constants';
import { resetImageGeneration } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { useAiPhotoGenerationAnalyticData } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.hooks';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './AiPhotoGenerationResetModal.css';

export interface DuplicatesRemoveAllModalProps {
    onClose?(): void;
}

const modal_type = 'generation-reset';

export const AiPhotoGenerationResetModal: FC<DuplicatesRemoveAllModalProps> = memo(function AiGenerationResetModal(props) {
    const { onClose } = props;

    const dispatch = useDispatch();
    const analyticData = useAiPhotoGenerationAnalyticData();

    const renderHeader = useCallback(() => <h3 className={styles.title}>Сгенерировать новое изображение?</h3>, []);

    const renderContent = useCallback(
        () => <Text className={styles.description}>Готовое изображение удалится&nbsp;&mdash; восстановить его&nbsp;не&nbsp;получится</Text>,
        []
    );

    const handleDismiss = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-close',
            modal_type,
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type', 'paid_user', 'corp_user']],
        });
    }, [analyticData]);

    const handleSuccess = useCallback(() => {
        dispatch(resetImageGeneration({ savePrompt: true }));
        onClose?.();

        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-click',
            action_type: 'success',
            modal_type,
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type', 'paid_user', 'corp_user']],
        });
    }, [analyticData, dispatch, onClose]);

    const handleCancel = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-click',
            action_type: 'cancel',
            modal_type,
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type', 'paid_user', 'corp_user']],
        });
    }, [analyticData]);

    const handleShow = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.aiPhotoGeneration,
            action: 'modal-show',
            modal_type,
            ...analyticData,
            dwh_enabled: true,
            dwh_enabled_fields: [['modal_type', 'paid_user', 'corp_user']],
        });
    }, [analyticData]);

    return (
        <BaseConfirmDialog
            size="small"
            dataQAId="ai-generation-reset-modal"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            successButtonText="Сгенерировать"
            cancelButtonText="Не генерировать"
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={onClose}
            onDismiss={handleDismiss}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            onShow={handleShow}
            isDarkTheme={true}
            className={VK_UI_DARK_THEME}
        />
    );
});
